const t = "liquid-ajax-cart",
  e = "data-ajax-cart",
  n = "ajax-cart",
  o = "js-ajax-cart",
  i = `${t}:init`;
var r = function (t2, e2, n2, o2) {
  return new (n2 || (n2 = Promise))(function (i2, r2) {
    function a2(t3) {
      try {
        u2(o2.next(t3));
      } catch (t4) {
        r2(t4);
      }
    }
    function s2(t3) {
      try {
        u2(o2.throw(t3));
      } catch (t4) {
        r2(t4);
      }
    }
    function u2(t3) {
      var e3;
      t3.done
        ? i2(t3.value)
        : ((e3 = t3.value),
          e3 instanceof n2
            ? e3
            : new n2(function (t4) {
                t4(e3);
              })).then(a2, s2);
    }
    u2((o2 = o2.apply(t2, [])).next());
  });
};
const a = "add",
  s = "change",
  u = "update",
  c = "clear",
  l = "get",
  d = `${t}:queue-start`,
  f = `${t}:queue-start-internal`,
  h = `${t}:queue-empty-internal`,
  p = `${t}:queue-end-internal`,
  m = `${t}:queue-end`,
  v = `${t}:request-start-internal`,
  y = `${t}:request-start`,
  b = `${t}:request-end-internal`,
  g = `${t}:request-end`,
  q = [];
let $ = false;
function w(t2) {
  var e2;
  (null === (e2 = t2.options) || void 0 === e2 ? void 0 : e2.important) && 0 !== q.length
    ? q[0].push(t2)
    : 1 === q.push([t2]) && (E(true), A());
}
function A() {
  if (1 === q.length && 0 === q[0].length) {
    const t3 = new CustomEvent(h);
    document.dispatchEvent(t3);
  }
  if (0 === q.length) return void E(false);
  if (0 === q[0].length) return (q.shift(), void A());
  const { requestType: t2, body: e2, options: n2 } = q[0][0];
  !(function (t3, e3, n3, o2) {
    var i2;
    const { extraRequestOnError: s2 } = W,
      u2 = k(t3);
    let c2;
    t3 !== l && (c2 = e3 || {});
    const d2 = t3 === l ? "GET" : "POST",
      f2 = n3.info || {},
      h2 = { requestType: t3, endpoint: u2, requestBody: c2, info: f2 },
      p2 = [],
      m2 = [],
      b2 = new CustomEvent(v, {
        detail: { requestState: { requestType: t3, endpoint: u2, info: f2, requestBody: c2 } },
      });
    document.dispatchEvent(b2);
    const g2 = new CustomEvent(y, {
      detail: { requestState: { requestType: t3, endpoint: u2, info: f2, requestBody: c2 } },
    });
    if ((document.dispatchEvent(g2), f2.cancel))
      return ((h2.responseData = null), void L(n3, o2, h2));
    if (null === (i2 = null == n3 ? void 0 : n3.signal) || void 0 === i2 ? void 0 : i2.aborted)
      return ((h2.responseData = null), (h2.fetchError = "AbortError"), void L(n3, o2, h2));
    if (void 0 !== c2) {
      let e4;
      if (
        (c2 instanceof FormData || c2 instanceof URLSearchParams
          ? c2.has("sections") && (e4 = c2.get("sections").toString())
          : (e4 = c2.sections),
        "string" == typeof e4 || e4 instanceof String || Array.isArray(e4))
      ) {
        if (
          (Array.isArray(e4) ? p2.push(...e4) : p2.push(...e4.split(",")),
          a === t3 && m2.push(...p2.slice(0, 5)),
          p2.length > 5)
        ) {
          m2.push(...p2.slice(5));
          const t4 = p2.slice(0, 5).join(",");
          c2 instanceof FormData || c2 instanceof URLSearchParams
            ? c2.set("sections", t4)
            : (c2.sections = t4);
        }
      } else
        null != e4 &&
          console.error(
            `Liquid Ajax Cart: "sections" parameter in a Cart Ajax API request must be a string or an array. Now it is ${e4}`
          );
    }
    const q2 = { method: d2 };
    ((null == n3 ? void 0 : n3.signal) && (q2.signal = n3.signal),
      t3 !== l &&
        (c2 instanceof FormData || c2 instanceof URLSearchParams
          ? ((q2.body = c2), (q2.headers = { "x-requested-with": "XMLHttpRequest" }))
          : ((q2.body = JSON.stringify(c2)),
            (q2.headers = { "Content-Type": "application/json" }))),
      fetch(u2, q2)
        .then((t4) =>
          r(this, void 0, void 0, function* () {
            const e4 = yield t4.json();
            return { ok: t4.ok, status: t4.status, body: e4 };
          })
        )
        .then((t4) =>
          r(this, void 0, void 0, function* () {
            var e4;
            return (
              (h2.responseData = t4),
              !h2.responseData.ok && s2 && m2.unshift(...p2.slice(0, 5)),
              m2.length > 0 &&
                ((null === (e4 = null == n3 ? void 0 : n3.signal) || void 0 === e4
                  ? void 0
                  : e4.aborted) ||
                  (h2.extraResponseData = yield S(m2, null == n3 ? void 0 : n3.signal))),
              h2
            );
          })
        )
        .catch((t4) => {
          ((!t4 || ("AbortError" !== t4.name && 20 !== t4.code)) &&
            (console.error("Liquid Ajax Cart: Error while performing cart Ajax request"),
            console.error(t4)),
            (h2.responseData = null),
            (h2.fetchError = t4));
        })
        .finally(() => {
          L(n3, o2, h2);
        }));
  })(t2, e2, n2, () => {
    (q[0].shift(), A());
  });
}
function E(t2) {
  $ = t2;
  const e2 = new CustomEvent($ ? f : p);
  document.dispatchEvent(e2);
  const n2 = new CustomEvent($ ? d : m);
  document.dispatchEvent(n2);
}
function L(t2, e2, n2) {
  if ("firstCallback" in t2)
    try {
      t2.firstCallback(n2);
    } catch (t3) {
      (console.error('Liquid Ajax Cart: Error in request "firstCallback" function'),
        console.error(t3));
    }
  const o2 = { requestState: n2 },
    i2 = new CustomEvent(b, { detail: o2 });
  document.dispatchEvent(i2);
  const r2 = new CustomEvent(g, { detail: o2 });
  if ((document.dispatchEvent(r2), "lastCallback" in t2))
    try {
      t2.lastCallback(n2);
    } catch (t3) {
      (console.error('Liquid Ajax Cart: Error in request "lastCallback" function'),
        console.error(t3));
    }
  e2();
}
function S(t2 = [], e2) {
  const n2 = { updates: {} };
  return (
    t2.length > 0 && (n2.sections = t2.slice(0, 5).join(",")),
    fetch(k(u), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(n2),
      signal: e2,
    }).then((n3) =>
      n3.json().then((o2) => {
        const i2 = { ok: n3.ok, status: n3.status, body: o2 };
        return t2.length < 6
          ? i2
          : S(t2.slice(5), e2).then((t3) => {
              var e3;
              return (
                t3.ok &&
                  (null === (e3 = t3.body) || void 0 === e3 ? void 0 : e3.sections) &&
                  "object" == typeof t3.body.sections &&
                  ("sections" in i2.body || (i2.body.sections = {}),
                  (i2.body.sections = Object.assign(
                    Object.assign({}, i2.body.sections),
                    t3.body.sections
                  ))),
                i2
              );
            });
      })
    )
  );
}
function j(t2 = {}) {
  w({ requestType: l, body: void 0, options: t2 });
}
function x(t2 = {}, e2 = {}) {
  w({ requestType: a, body: t2, options: e2 });
}
function C(t2 = {}, e2 = {}) {
  w({ requestType: s, body: t2, options: e2 });
}
function T(t2 = {}, e2 = {}) {
  w({ requestType: u, body: t2, options: e2 });
}
function D(t2 = {}, e2 = {}) {
  w({ requestType: c, body: t2, options: e2 });
}
function k(t2) {
  var e2, n2, o2, i2, r2, d2, f2, h2, p2, m2;
  switch (t2) {
    case a:
      return `${(null === (n2 = null === (e2 = window.Shopify) || void 0 === e2 ? void 0 : e2.routes) || void 0 === n2 ? void 0 : n2.root) || "/"}cart/add.js`;
    case s:
      return `${(null === (i2 = null === (o2 = window.Shopify) || void 0 === o2 ? void 0 : o2.routes) || void 0 === i2 ? void 0 : i2.root) || "/"}cart/change.js`;
    case l:
      return `${(null === (d2 = null === (r2 = window.Shopify) || void 0 === r2 ? void 0 : r2.routes) || void 0 === d2 ? void 0 : d2.root) || "/"}cart.js`;
    case c:
      return `${(null === (h2 = null === (f2 = window.Shopify) || void 0 === f2 ? void 0 : f2.routes) || void 0 === h2 ? void 0 : h2.root) || "/"}cart/clear.js`;
    case u:
      return `${(null === (m2 = null === (p2 = window.Shopify) || void 0 === p2 ? void 0 : p2.routes) || void 0 === m2 ? void 0 : m2.root) || "/"}cart/update.js`;
    default:
      return;
  }
}
function _() {
  return $;
}
const O = `${e}-initial-state`;
let N,
  R = null;
function M() {
  return { cart: R, previousCart: N };
}
const B = `${e}-bind`;
function H() {
  M().cart &&
    document.querySelectorAll(`[${B}]`).forEach((t2) => {
      const e2 = t2.getAttribute(B);
      t2.textContent = (function (t3) {
        const { binderFormatters: e3 } = W,
          [n2, ...o2] = t3.split("|");
        let i2 = F(n2, M().cart);
        return (
          o2.forEach((t4) => {
            const n3 = t4.trim();
            "" !== n3 &&
              ("object" == typeof e3 && n3 in e3
                ? (i2 = e3[n3](i2))
                : n3 in P
                  ? (i2 = P[n3](i2))
                  : console.warn(`Liquid Ajax Cart: the "${n3}" formatter is not found`));
          }),
          "string" == typeof i2 ||
          i2 instanceof String ||
          "number" == typeof i2 ||
          i2 instanceof Number
            ? i2.toString()
            : (console.error(
                `Liquid Ajax Cart: the calculated value for the ${B}="${t3}" element must be string or number. But the value is`,
                i2
              ),
              "")
        );
      })(e2);
    });
}
function F(t2, e2) {
  const n2 = t2.split("."),
    o2 = n2.shift().trim();
  return "" !== o2 && o2 in e2 && n2.length > 0 ? F(n2.join("."), e2[o2]) : e2[o2];
}
const P = {
  money_with_currency: (t2) => {
    var e2;
    const n2 = M();
    if ("number" != typeof t2 && !(t2 instanceof Number))
      return (
        console.error(
          "Liquid Ajax Cart: the 'money_with_currency' formatter is not applied because the value is not a number. The value is ",
          t2
        ),
        t2
      );
    const o2 = t2 / 100;
    return "Intl" in window &&
      (null === (e2 = window.Shopify) || void 0 === e2 ? void 0 : e2.locale)
      ? Intl.NumberFormat(window.Shopify.locale, {
          style: "currency",
          currency: n2.cart.currency,
        }).format(o2)
      : `${o2.toFixed(2)} ${n2.cart.currency}`;
  },
};
let U,
  I = false;
function J() {
  const { mutations: t2 } = W;
  (Array.isArray(t2) ||
    console.error('Liquid Ajax Cart: the "mutations" settings parameter must be an array'),
    0 !== t2.length && ((I = false), (U = -1), V()));
}
function V() {
  const { mutations: t2 } = W;
  if ((U++, U >= t2.length)) return;
  let e2 = [];
  try {
    const n2 = t2[U]();
    n2 && (e2 = (null == n2 ? void 0 : n2.requests) || []);
  } catch (t3) {
    (console.error(`Liquid Ajax Cart: Error in the "mutation" function with index ${U}`),
      console.error(t3));
  }
  Array.isArray(e2) ? Z(e2) : V();
}
function Z(t2) {
  const e2 = t2.shift();
  if (e2) {
    if (e2.type && [a, s, u, c, l].includes(e2.type))
      return void w({
        requestType: e2.type,
        body: e2.body,
        options: {
          info: { initiator: "mutation" },
          important: true,
          lastCallback: (e3) => {
            Z(t2);
          },
        },
      });
    console.error(`Liquid Ajax Cart: wrong request type in the mutation with index ${U}`);
  }
  t2.length > 0 ? Z(t2) : V();
}
const W = {
    binderFormatters: {},
    requestErrorText: "There was an error while updating your cart. Please try again.",
    updateOnWindowFocus: true,
    quantityTagAllowZero: false,
    quantityTagDebounce: 300,
    mutations: [],
    extraRequestOnError: true,
  },
  z = `${e}-section`,
  G = `${e}-static-element`,
  K = `${e}-section-scroll`,
  X = "shopify-section-",
  Q = `${n}-product-form`,
  Y = "processing";
class tt extends HTMLElement {
  connectedCallback() {
    var t2, e2;
    const n2 = this,
      o2 = this.querySelectorAll("form");
    if (1 !== o2.length)
      return void console.error(
        `Liquid Ajax Cart: "${Q}" element must have one "form" element as a child, ${o2.length} found`,
        n2
      );
    const i2 = o2[0];
    new URL(i2.action).pathname ===
    `${(null === (e2 = null === (t2 = window.Shopify) || void 0 === t2 ? void 0 : t2.routes) || void 0 === e2 ? void 0 : e2.root) || "/"}cart/add`
      ? i2.addEventListener("submit", (t3) => {
          if (!n2.hasAttribute(Y)) {
            const t4 = new FormData(i2);
            (n2.setAttribute(Y, ""),
              x(t4, {
                lastCallback: () => {
                  n2.removeAttribute(Y);
                },
                info: { initiator: n2 },
              }));
          }
          t3.preventDefault();
        })
      : console.error(
          `Liquid Ajax Cart: "${Q}" element's form "action" attribute value isn't a product form action URL`,
          i2,
          n2
        );
  }
}
var et, nt, ot, it, rt, at, st, ut;
const ct = `${(null === (nt = null === (et = window.Shopify) || void 0 === et ? void 0 : et.routes) || void 0 === nt ? void 0 : nt.root) || "/"}cart/change`,
  lt = `${(null === (it = null === (ot = window.Shopify) || void 0 === ot ? void 0 : ot.routes) || void 0 === it ? void 0 : it.root) || "/"}cart/add`,
  dt = `${(null === (at = null === (rt = window.Shopify) || void 0 === rt ? void 0 : rt.routes) || void 0 === at ? void 0 : at.root) || "/"}cart/clear`,
  ft = `${(null === (ut = null === (st = window.Shopify) || void 0 === st ? void 0 : st.routes) || void 0 === ut ? void 0 : ut.root) || "/"}cart/update`,
  ht = `${e}-request-button`;
function pt(t2, e2) {
  let n2;
  const o2 = [ct, lt, dt, ft];
  if (!t2.hasAttribute(ht)) return;
  const i2 = t2.getAttribute(ht);
  if (i2) {
    let t3;
    try {
      if (((t3 = new URL(i2, window.location.origin)), !o2.includes(t3.pathname)))
        throw `URL should be one of the following: ${ct}, ${lt}, ${ft}, ${dt}`;
      n2 = t3;
    } catch (t4) {
      console.error(`Liquid Ajax Cart: ${ht} contains an invalid URL as a parameter.`, t4);
    }
  } else if (t2 instanceof HTMLAnchorElement && t2.hasAttribute("href")) {
    const e3 = new URL(t2.href);
    o2.includes(e3.pathname)
      ? (n2 = e3)
      : t2.hasAttribute(ht) &&
        console.error(
          `Liquid Ajax Cart: a link with the ${ht} contains an invalid href URL.`,
          `URL should be one of the following: ${ct}, ${lt}, ${ft}, ${dt}`
        );
  }
  if (void 0 === n2)
    return void console.error(`Liquid Ajax Cart: a ${ht} element doesn't have a valid URL`);
  if ((e2 && e2.preventDefault(), _())) return;
  const r2 = new FormData();
  switch (
    (n2.searchParams.forEach((t3, e3) => {
      r2.append(e3, t3);
    }),
    n2.pathname)
  ) {
    case lt:
      x(r2, { info: { initiator: t2 } });
      break;
    case ct:
      C(r2, { info: { initiator: t2 } });
      break;
    case ft:
      T(r2, { info: { initiator: t2 } });
      break;
    case dt:
      D({}, { info: { initiator: t2 } });
  }
}
function mt(t2, e2) {
  let n2, o2;
  return (
    t2.length > 3
      ? ((n2 = e2.cart.items.find((e3) => e3.key === t2)), (o2 = "id"))
      : ((n2 = e2.cart.items[Number(t2) - 1]), (o2 = "line")),
    void 0 === n2 &&
      ((n2 = null), console.error(`Liquid Ajax Cart: line item with ${o2}="${t2}" not found`)),
    [n2, o2]
  );
}
const vt = `${e}-quantity-input`;
function yt(t2) {
  return !(
    !t2.hasAttribute(vt) ||
    (!(
      (t2 instanceof HTMLInputElement && ["text", "number"].includes(t2.type)) ||
      (t2 instanceof HTMLSelectElement && ["select-one"].includes(t2.type))
    ) &&
      (console.error(
        `Liquid Ajax Cart: the ${vt} attribute supports "input" elements of types "text", "number" and non-multiple "select" elements`
      ),
      1))
  );
}
function bt() {
  document.querySelectorAll(`input[${vt}], select[${vt}]`).forEach((t2) => {
    if (!yt(t2)) return;
    if (_()) return void (t2.disabled = true);
    const e2 = M(),
      n2 = t2.getAttribute(vt).trim(),
      [o2] = mt(n2, e2);
    (o2 ? (t2.value = o2.quantity.toString()) : null === o2 && (t2.value = "0"),
      (t2.disabled = false));
  });
}
function gt(t2, e2) {
  if (!yt(t2)) return;
  if ((e2 && e2.preventDefault(), _())) return;
  let n2 = Number(t2.value.trim());
  const o2 = t2.getAttribute(vt).trim();
  if (isNaN(n2))
    return void console.error(`Liquid Ajax Cart: input value of a ${vt} must be an Integer number`);
  if ((n2 < 1 && (n2 = 0), !o2))
    return void console.error(
      `Liquid Ajax Cart: attribute value of a ${vt} must be an item key or an item index`
    );
  const i2 = o2.length > 3 ? "id" : "line",
    r2 = new FormData();
  (r2.set(i2, o2),
    r2.set("quantity", n2.toString()),
    C(r2, { info: { initiator: t2 } }),
    t2.blur());
}
const qt = `${e}-property-input`;
function $t(t2) {
  const e2 = t2.getAttribute(qt),
    n2 = t2.getAttribute("name");
  console.error(
    `Liquid Ajax Cart: the element [${qt}="${e2}"]${n2 ? `[name="${n2}"]` : ""} has wrong attributes.`
  );
}
function wt(t2) {
  return (
    !!t2.hasAttribute(qt) &&
    !!(
      (t2 instanceof HTMLInputElement && "hidden" !== t2.type) ||
      t2 instanceof HTMLTextAreaElement ||
      t2 instanceof HTMLSelectElement
    )
  );
}
function At(t2) {
  const e2 = { objectCode: void 0, propertyName: void 0, attributeValue: void 0 };
  if (!t2.hasAttribute(qt)) return e2;
  let n2 = t2.getAttribute(qt).trim();
  if (!n2) {
    const e3 = t2.getAttribute("name").trim();
    e3 && (n2 = e3);
  }
  if (!n2) return ($t(t2), e2);
  if (((e2.attributeValue = n2), "note" === n2)) return ((e2.objectCode = "note"), e2);
  let [o2, ...i2] = n2.trim().split("[");
  return !i2 || 1 !== i2.length || i2[0].length < 2 || i2[0].indexOf("]") !== i2[0].length - 1
    ? ($t(t2), e2)
    : ((e2.objectCode = o2), (e2.propertyName = i2[0].replace("]", "")), e2);
}
function Et() {
  document.querySelectorAll(`[${qt}]`).forEach((t2) => {
    if (!wt(t2)) return;
    if (_()) return void (t2.disabled = true);
    const { objectCode: e2, propertyName: n2, attributeValue: o2 } = At(t2);
    if (!e2) return;
    const i2 = M();
    let r2,
      a2 = false;
    if ("note" === e2) r2 = i2.cart.note;
    else if ("attributes" === e2) r2 = i2.cart.attributes[n2];
    else {
      const [t3, s2] = mt(e2, i2);
      (t3 && (r2 = t3.properties[n2]),
        null === t3 &&
          (console.error(
            `Liquid Ajax Cart: line item with ${s2}="${e2}" was not found when the [${qt}] element with "${o2}" value tried to get updated from the State`
          ),
          (a2 = true)));
    }
    (t2 instanceof HTMLInputElement && ("checkbox" === t2.type || "radio" === t2.type)
      ? (t2.checked = t2.value === r2)
      : ("string" == typeof r2 ||
          r2 instanceof String ||
          "number" == typeof r2 ||
          r2 instanceof Number ||
          (Array.isArray(r2) || r2 instanceof Object
            ? ((r2 = JSON.stringify(r2)),
              console.warn(
                `Liquid Ajax Cart: the ${qt} with the "${o2}" value is bound to the ${n2} ${"attributes" === e2 ? "attribute" : "property"} that is not string or number: ${r2}`
              ))
            : (r2 = "")),
        (t2.value = r2)),
      a2 || (t2.disabled = false));
  });
}
function Lt(t2, e2) {
  if (!wt(t2)) return;
  (e2 && e2.preventDefault(), t2.blur());
  const n2 = M();
  if (_()) return;
  const { objectCode: o2, propertyName: i2, attributeValue: r2 } = At(t2);
  if (!o2) return;
  let a2 = t2.value;
  if (t2 instanceof HTMLInputElement && "checkbox" === t2.type && !t2.checked) {
    let t3 = document.querySelector(`input[type="hidden"][${qt}="${r2}"]`);
    (t3 ||
      ("note" !== o2 && "attributes" !== o2) ||
      (t3 = document.querySelector(`input[type="hidden"][${qt}][name="${r2}"]`)),
      (a2 = t3 ? t3.value : ""));
  }
  if ("note" === o2) {
    const e3 = new FormData();
    (e3.set("note", a2), T(e3, { info: { initiator: t2 } }));
  } else if ("attributes" === o2) {
    const e3 = new FormData();
    (e3.set(`attributes[${i2}]`, a2), T(e3, { info: { initiator: t2 } }));
  } else {
    const [e3, s2] = mt(o2, n2);
    if (
      (null === e3 &&
        console.error(
          `Liquid Ajax Cart: line item with ${s2}="${o2}" was not found when the [${qt}] element with "${r2}" value tried to update the cart`
        ),
      !e3)
    )
      return;
    const u2 = Object.assign({}, e3.properties);
    u2[i2] = a2;
    const c2 = new FormData();
    let l2 = c2;
    (c2.set(s2, o2), c2.set("quantity", e3.quantity.toString()));
    for (let t3 in u2) {
      const n3 = u2[t3];
      "string" == typeof n3 || n3 instanceof String
        ? c2.set(`properties[${t3}]`, u2[t3])
        : (l2 = { [s2]: o2, quantity: e3.quantity, properties: u2 });
    }
    C(l2, { info: { initiator: t2 } });
  }
}
const St = `${n}-quantity`,
  jt = `${e}-quantity-plus`,
  xt = `${e}-quantity-minus`;
function Ct() {
  (customElements.define(Q, tt),
    document.addEventListener(
      "click",
      function (t2) {
        for (let e2 = t2.target; e2 && e2 != document.documentElement; e2 = e2.parentElement)
          pt(e2, t2);
      },
      false
    ),
    document.addEventListener(
      "change",
      function (t2) {
        Lt(t2.target, t2);
      },
      false
    ),
    document.addEventListener(
      "keydown",
      function (t2) {
        const e2 = t2.target;
        ("Enter" === t2.key && ((e2 instanceof HTMLTextAreaElement && !t2.ctrlKey) || Lt(e2, t2)),
          "Escape" === t2.key &&
            (function (t3) {
              if (!wt(t3)) return;
              if (!(t3 instanceof HTMLInputElement || t3 instanceof HTMLTextAreaElement)) return;
              if (t3 instanceof HTMLInputElement && ("checkbox" === t3.type || "radio" === t3.type))
                return;
              const e3 = M(),
                { objectCode: n2, propertyName: o2 } = At(t3);
              if (!n2) return;
              let i2;
              if ("note" === n2) i2 = e3.cart.note;
              else if ("attributes" === n2) i2 = e3.cart.attributes[o2];
              else {
                const [t4] = mt(n2, e3);
                t4 && (i2 = t4.properties[o2]);
              }
              (void 0 !== i2 &&
                (i2 || "string" == typeof i2 || i2 instanceof String || (i2 = ""),
                (t3.value = String(i2))),
                t3.blur());
            })(e2));
      },
      false
    ),
    document.addEventListener(f, Et),
    document.addEventListener(b, Et),
    document.addEventListener(p, Et),
    Et(),
    document.addEventListener(
      "change",
      function (t2) {
        gt(t2.target, t2);
      },
      false
    ),
    document.addEventListener(
      "keydown",
      function (t2) {
        ("Enter" === t2.key && gt(t2.target, t2),
          "Escape" === t2.key &&
            (function (t3) {
              if (!yt(t3)) return;
              const e2 = t3.getAttribute(vt).trim();
              let n2;
              const o2 = M();
              if (e2.length > 3) n2 = o2.cart.items.find((t4) => t4.key === e2);
              else {
                const t4 = Number(e2) - 1;
                n2 = o2.cart.items[t4];
              }
              (n2 && (t3.value = n2.quantity.toString()), t3.blur());
            })(t2.target));
      },
      false
    ),
    document.addEventListener(f, bt),
    document.addEventListener(b, bt),
    document.addEventListener(p, bt),
    bt(),
    customElements.define(
      St,
      class extends HTMLElement {
        constructor() {
          (super(...arguments), (this._timer = void 0));
        }
        connectedCallback() {
          const t2 = this.querySelectorAll("input");
          1 === t2.length
            ? ((this._$input = t2[0]),
              this._$input.hasAttribute(vt)
                ? ((this._$buttons = Array.from(this.querySelectorAll(`[${xt}], [${jt}]`))),
                  this._$input.addEventListener("change", this._updateDOM.bind(this)),
                  document.addEventListener(f, this._updateDOM.bind(this)),
                  document.addEventListener(b, this._updateDOM.bind(this)),
                  document.addEventListener(p, this._updateDOM.bind(this)),
                  this._updateDOM(),
                  this._$buttons.forEach((t3) => {
                    (t3.addEventListener("click", (e2) => {
                      const { quantityTagAllowZero: n2 } = W,
                        o2 = true === n2 ? 0 : 1;
                      if (!_()) {
                        const e3 = Number(this._$input.value);
                        if (isNaN(e3))
                          return void console.error(
                            `Liquid Ajax Cart: "${St}" element's input value isn't a number`,
                            this._$input,
                            this
                          );
                        let n3 = e3,
                          i2 = Number(this._$input.getAttribute("step") || 1);
                        ((!Number.isSafeInteger(i2) || i2 <= 0) && (i2 = 1),
                          (n3 = t3.hasAttribute(jt) ? n3 + i2 : n3 - i2),
                          n3 < o2 && (n3 = o2),
                          n3 !== e3 &&
                            ((this._$input.value = n3.toString()),
                            this._runAwaiting(),
                            this._updateDOM()));
                      }
                      e2.preventDefault();
                    }),
                      t3.addEventListener("focusout", (e2) => {
                        (e2.relatedTarget && t3.contains(e2.relatedTarget)) ||
                          (void 0 !== this._timer && this._runRequest());
                      }));
                  }))
                : console.error(
                    `Liquid Ajax Cart: "${St}" element's input must have the "${vt}" attribute`,
                    this._$input,
                    this
                  ))
            : console.error(
                `Liquid Ajax Cart: "${St}" element must have one "input" element as a child, ${t2.length} found`,
                this
              );
        }
        _runAwaiting() {
          const { quantityTagDebounce: t2 } = W;
          (void 0 !== this._timer && clearTimeout(this._timer),
            t2 > 0
              ? (this._timer = setTimeout(() => {
                  this._runRequest();
                }, Number(t2)))
              : this._runRequest());
        }
        _runRequest() {
          (void 0 !== this._timer && clearTimeout(this._timer),
            (this._timer = void 0),
            _() || this._$input.dispatchEvent(new Event("change", { bubbles: true })));
        }
        _updateDOM() {
          this._$buttons.forEach((t2) => {
            const e2 =
              _() || (t2.hasAttribute(xt) && !W.quantityTagAllowZero && "1" === this._$input.value);
            (e2 ? t2.setAttribute("aria-disabled", "true") : t2.removeAttribute("aria-disabled"),
              t2 instanceof HTMLButtonElement && t2.toggleAttribute("disabled", e2));
          });
        }
      }
    ));
}
const Tt = `${e}-errors`,
  Dt = (t2) => {
    switch (t2.requestType) {
      case a:
        return ((t3) => {
          var e2;
          const n2 = null === (e2 = t3.info) || void 0 === e2 ? void 0 : e2.initiator;
          return n2 instanceof tt ? Array.from(n2.querySelectorAll(`[${Tt}="form"]`)) : [];
        })(t2);
      case s:
        return ((t3) => {
          var e2;
          const n2 = [],
            o2 = M();
          let i2, r2;
          if (
            (t3.requestBody instanceof FormData || t3.requestBody instanceof URLSearchParams
              ? (t3.requestBody.has("line") && (r2 = t3.requestBody.get("line").toString()),
                t3.requestBody.has("id") && (i2 = t3.requestBody.get("id").toString()))
              : ("line" in t3.requestBody && (r2 = String(t3.requestBody.line)),
                "id" in t3.requestBody && (i2 = String(t3.requestBody.id))),
            r2)
          ) {
            const t4 = Number(r2);
            if (t4 > 0) {
              const n3 = t4 - 1;
              i2 = null === (e2 = o2.cart.items[n3]) || void 0 === e2 ? void 0 : e2.key;
            }
          }
          return (
            i2 &&
              (i2.indexOf(":") > -1
                ? n2.push(...Array.from(document.querySelectorAll(`[${Tt}="${i2}"]`)))
                : n2.push(
                    ...Array.from(
                      document.querySelectorAll(
                        o2.cart.items
                          .reduce(
                            (t4, e3) => (
                              (e3.key !== i2 && e3.id !== Number(i2)) ||
                                t4.push(`[${Tt}="${e3.key}"]`),
                              t4
                            ),
                            []
                          )
                          .join(",")
                      )
                    )
                  )),
            n2
          );
        })(t2);
      default:
        return [];
    }
  },
  kt = `${o}-init`,
  _t = `${o}-processing`,
  Ot = `${o}-empty`,
  Nt = `${o}-not-empty`;
function Rt() {
  const t2 = document.querySelector("html"),
    e2 = M();
  (t2.classList.toggle(kt, null !== e2.cart),
    t2.classList.toggle(_t, _()),
    t2.classList.toggle(Ot, 0 === e2.cart.item_count),
    t2.classList.toggle(Nt, e2.cart.item_count > 0));
}
let Mt = false;
if (!("liquidAjaxCart" in window)) {
  let Bt = function (t2, e2) {
    Object.defineProperty(window.liquidAjaxCart, t2, {
      get: e2,
      set: () => {
        throw new Error(`Liquid Ajax Cart: the "${t2}" is a read-only property`);
      },
      enumerable: true,
    });
  };
  var Bt2 = Bt;
  ((window.liquidAjaxCart = {
    conf: function (t2, e2) {
      t2 in W
        ? ((W[t2] = e2),
          window.liquidAjaxCart.init &&
            ("binderFormatters" === t2 && H(), "mutations" === t2 && J()))
        : console.error(`Liquid Ajax Cart: unknown configuration parameter "${t2}"`);
    },
  }),
    Bt("init", () => Mt),
    document.addEventListener(v, (t2) => {
      const { requestState: e2 } = t2.detail;
      if (void 0 !== e2.requestBody) {
        const t3 = [];
        if (
          (document.querySelectorAll(`[${z}]`).forEach((e3) => {
            const n2 = e3.closest(`[id^="${X}"]`);
            if (n2) {
              const e4 = n2.id.replace(X, "");
              -1 === t3.indexOf(e4) && t3.push(e4);
            } else
              console.error(
                `Liquid Ajax Cart: there is a ${z} element that is not inside a Shopify section. All the ${z} elements must be inside Shopify sections.`
              );
          }),
          t3.length)
        ) {
          let n2,
            o2 = t3.join(",");
          (e2.requestBody instanceof FormData || e2.requestBody instanceof URLSearchParams
            ? e2.requestBody.has("sections") && (n2 = e2.requestBody.get("sections").toString())
            : (n2 = e2.requestBody.sections),
            ((("string" == typeof n2 || n2 instanceof String) && "" !== n2) ||
              (n2 && Array.isArray(n2) && n2.length > 0)) &&
              (o2 = `${n2.toString()},${o2}`),
            e2.requestBody instanceof FormData || e2.requestBody instanceof URLSearchParams
              ? e2.requestBody.set("sections", o2)
              : (e2.requestBody.sections = o2));
        }
      }
    }),
    document.addEventListener(b, (t2) => {
      var e2, n2, o2, i2;
      t2.detail.sections = [];
      const { requestState: r2 } = t2.detail,
        s2 = new DOMParser(),
        u2 = [];
      if (
        r2.responseData.body.sections ||
        (null === (n2 = null === (e2 = r2.extraResponseData) || void 0 === e2 ? void 0 : e2.body) ||
        void 0 === n2
          ? void 0
          : n2.sections)
      ) {
        let t3 = r2.responseData.body.sections;
        (null === (i2 = null === (o2 = r2.extraResponseData) || void 0 === o2 ? void 0 : o2.body) ||
        void 0 === i2
          ? void 0
          : i2.sections) &&
          (t3 = Object.assign(Object.assign({}, t3), r2.extraResponseData.body.sections));
        for (let e3 in t3)
          t3[e3]
            ? document.querySelectorAll(`#shopify-section-${e3}`).forEach((n3) => {
                let o3 = [];
                const i3 = "__noId__",
                  c2 = {};
                n3.querySelectorAll(` [${K}] `).forEach((t4) => {
                  let e4 = t4.getAttribute(K).toString().trim();
                  ("" === e4 && (e4 = i3),
                    e4 in c2 || (c2[e4] = []),
                    c2[e4].push({ scroll: t4.scrollTop, height: t4.scrollHeight }));
                });
                const l2 = {},
                  d2 = n3.querySelectorAll(`[${G}]`);
                d2 &&
                  d2.forEach((t4) => {
                    let e4 = t4.getAttribute(G).toString().trim();
                    ("" === e4 && (e4 = i3), e4 in l2 || (l2[e4] = []), l2[e4].push(t4));
                  });
                const f2 = n3.querySelectorAll(`[${z}]`);
                if (f2) {
                  const r3 = s2.parseFromString(t3[e3], "text/html");
                  r3.querySelectorAll('img[loading="lazy"]').forEach((t4) => {
                    t4.removeAttribute("loading");
                  });
                  for (let t4 in l2)
                    r3.querySelectorAll(` [${G}="${t4.replace(i3, "")}"] `).forEach((e4, n4) => {
                      n4 + 1 <= l2[t4].length &&
                        (e4.before(l2[t4][n4]), e4.parentElement.removeChild(e4));
                    });
                  const a2 = r3.querySelectorAll(`[${z}]`);
                  if (f2.length !== a2.length) {
                    console.error(
                      `Liquid Ajax Cart: the received HTML for the "${e3}" section has a different quantity of the "${z}" containers. The section will be updated completely.`
                    );
                    const t4 = r3.querySelector(`#${X}${e3}`);
                    if (t4) {
                      for (n3.innerHTML = ""; t4.childNodes.length; ) n3.appendChild(t4.firstChild);
                      o3.push(n3);
                    }
                  } else
                    f2.forEach((t4, e4) => {
                      (t4.before(a2[e4]), t4.parentElement.removeChild(t4), o3.push(a2[e4]));
                    });
                }
                for (let t4 in c2)
                  n3.querySelectorAll(` [${K}="${t4.replace(i3, "")}"] `).forEach((e4, n4) => {
                    n4 + 1 <= c2[t4].length &&
                      (r2.requestType !== a || c2[t4][n4].height >= e4.scrollHeight) &&
                      (e4.scrollTop = c2[t4][n4].scroll);
                  });
                o3.length > 0 && u2.push({ id: e3, elements: o3 });
              })
            : console.error(
                `Liquid Ajax Cart: the HTML for the "${e3}" section was requested but the response is ${t3[e3]}`
              );
      }
      u2.length > 0 && (t2.detail.sections = u2);
    }),
    document.addEventListener(v, (t2) => {
      const { requestState: e2 } = t2.detail;
      Dt(e2).forEach((t3) => {
        t3.textContent = "";
      });
    }),
    document.addEventListener(b, (t2) => {
      const { requestState: e2 } = t2.detail;
      if (e2.info.cancel) return;
      const n2 = Dt(e2);
      if (0 === n2.length) return;
      const o2 = (function (t3) {
        var e3, n3, o3, i2, r2, a2, s2;
        const { requestErrorText: u2 } = W;
        if (null === (e3 = t3.responseData) || void 0 === e3 ? void 0 : e3.ok) return "";
        const c2 =
          (null === (o3 = null === (n3 = t3.responseData) || void 0 === n3 ? void 0 : n3.body) ||
          void 0 === o3
            ? void 0
            : o3.errors) ||
          (null === (r2 = null === (i2 = t3.responseData) || void 0 === i2 ? void 0 : i2.body) ||
          void 0 === r2
            ? void 0
            : r2.description) ||
          (null === (s2 = null === (a2 = t3.responseData) || void 0 === a2 ? void 0 : a2.body) ||
          void 0 === s2
            ? void 0
            : s2.message);
        return c2
          ? "string" == typeof c2
            ? c2
            : "object" == typeof c2
              ? Object.values(c2)
                  .map((t4) => t4.join(", "))
                  .join("; ")
              : u2
          : u2;
      })(e2);
      o2 &&
        n2.forEach((t3) => {
          t3.textContent = o2;
        });
    }),
    document.addEventListener(i, J),
    document.addEventListener(h, () => {
      I && J();
    }),
    document.addEventListener(v, (t2) => {
      const { requestState: e2 } = t2.detail;
      "mutation" !== e2.info.initiator && (I = true);
    }),
    (function () {
      document.addEventListener(b, (t3) => {
        var e2, n2;
        const { requestState: o2 } = t3.detail;
        let i2;
        ((null === (e2 = o2.extraResponseData) || void 0 === e2 ? void 0 : e2.ok) &&
        o2.extraResponseData.body.token
          ? (i2 = o2.extraResponseData.body)
          : (null === (n2 = o2.responseData) || void 0 === n2 ? void 0 : n2.ok) &&
            o2.responseData.body.token &&
            (i2 = o2.responseData.body),
          i2 && ((N = R), (R = i2), (t3.detail.previousCart = N), (t3.detail.cart = R)));
      });
      const t2 = document.querySelector(`[${O}]`);
      if (t2)
        try {
          R = JSON.parse(t2.textContent);
        } catch (t3) {
          (console.error(`Liquid Ajax Cart: can't parse cart JSON from the "${O}" script`),
            console.error(t3));
        }
      return new Promise((t3, e2) => {
        var n2, o2;
        R
          ? t3()
          : fetch(
              `${(null === (o2 = null === (n2 = window.Shopify) || void 0 === n2 ? void 0 : n2.routes) || void 0 === o2 ? void 0 : o2.root) || "/"}cart.js`,
              { headers: { "Content-Type": "application/json" } }
            )
              .then((t4) => t4.json())
              .then((e3) => {
                ((R = e3), t3());
              })
              .catch((t4) => {
                (console.error(t4), e2(`Can't load the cart state from the "/cart.js" endpoint`));
              });
      });
    })().then(() => {
      (document.addEventListener(b, H),
        H(),
        Ct(),
        document.addEventListener(f, Rt),
        document.addEventListener(b, Rt),
        document.addEventListener(p, Rt),
        Rt(),
        (window.liquidAjaxCart.get = j),
        (window.liquidAjaxCart.add = x),
        (window.liquidAjaxCart.change = C),
        (window.liquidAjaxCart.update = T),
        (window.liquidAjaxCart.clear = D),
        Bt("cart", () => M().cart),
        Bt("processing", _),
        window.addEventListener("focus", () => {
          W.updateOnWindowFocus && T({}, {});
        }),
        window.addEventListener("pageshow", (t3) => {
          (t3.persisted || "back_forward" === performance.getEntriesByType("navigation")[0].type) &&
            window.liquidAjaxCart.update({}, {});
        }),
        (Mt = true));
      const t2 = new CustomEvent(i);
      document.dispatchEvent(t2);
    }));
}
